import HomeBannerSection from '../home/HomeBannerSection';
import HomeNeedLoanSection from '../home/HomeNeedLoanSection';
import HomeWhatForSection from '../home/HomeWhatForSection';
import HomeDownloadAppSection from '../home/HomeDownloadAppSection';
import HomeFaqSection from '../home/HomeFaqSection';
import WtCalculatorNew from '../calculator/WtCalculatorNew';

const NewHome = () => (
  <>
    <HomeBannerSection />
    <WtCalculatorNew />
    <HomeNeedLoanSection />
    <HomeWhatForSection />
    <HomeDownloadAppSection />
    <HomeFaqSection />
  </>
);

export default NewHome;
